const validStatuses = ['VALID', 'NEED_RESET'];

export function isAuthorizedByBlackbox(blackboxData: Window['__BLACKBOX_DATA__']) {
    return Boolean(
        blackboxData &&
            // Не должно быть ошибки
            (!blackboxData.error || blackboxData.error === 'OK') &&
            // Должен быть статус 'VALID' или 'NEED_RESET'
            (!blackboxData.status || validStatuses.includes(blackboxData.status)),
    );
}

export function getAvatarSrc(avatar?: string) {
    if (!avatar) {
        return 'https://avatars.mds.yandex.net/get-yapic/18057972/NbnfpFSzqQp5FluiuEdXK61dkg-1/islands-200';
    }

    return `https://avatars.mds.yandex.net/get-yapic/${avatar}/islands-200`;
}
